// Links to the resources host or a bit.ly short link are downloads (press
// kits), shown with a download icon.
export const getDropButtonShowDownloadIcon = (
	link: string | null | undefined
) =>
	link?.startsWith?.('https://resources.heni.com') ||
	link?.startsWith?.('https://bit.ly/');
